setTimeout(function(){

  $('.sc_subscr_tit').click(function(){
    $(this).toggleClass('open');
    $('.subscr_wrap .complementary-wrapper').toggleClass('on');
  });
}, 2000);
/*
if($(window).width() > 767){
setTimeout(function(){
  
  $('.subscr_wrap').addClass('show');


      $('.sc_subscr_tit').click(function(){
        if($('.sc_subscr').hasClass('open')){
         $('.sc_subscr').removeClass('open');
          $('.sc_subscr').css('height',58);
        }else{
          $('.sc_subscr').addClass('open');
          $('.sc_subscr').css('height',168);
         
        }
        
      });
  
}, 1000);

} else {

   setTimeout(function(){
  
  $('.subscr_wrap').addClass('show');

  
      $('.sc_subscr_tit').click(function(){
        if($('.sc_subscr').hasClass('open')){
         $('.sc_subscr').removeClass('open');
          $('.sc_subscr').css('height',54);
        }else{
          $('.sc_subscr').addClass('open');
          $('.sc_subscr').css('height',140);
         
        }
        
      });
  
}, 1000);
   

 }
*/

setTimeout(function(){
  /*
  var complementary_item = $('.sc_subscr .complementary-products').length;
  if(complementary_item > 0){
    $('.subscr_wrap').addClass('show');
  }else{
    $('.subscr_wrap').hide();
  }

  var complementary_tit_h = $('.sc_subscr_tit').outerHeight();
  var complementary_tit_h_num = parseInt(complementary_tit_h);
  var complementary_h = $('.complementary-products').outerHeight();
  var complementary_h_num = parseInt(complementary_h);
  var complementary_total = complementary_h_num;
  
 $('.sc_subscr').css('height',complementary_tit_h_num);
  
      $('.sc_subscr_tit').click(function(){
        if($('.sc_subscr').hasClass('open')){
         $('.sc_subscr').removeClass('open');
          $('.sc_subscr').css('height',complementary_tit_h_num);
        }else{
          $('.sc_subscr').addClass('open');
          $('.sc_subscr').css('height',complementary_total);
         
        }
        
      });
        */
  
//
  $('.sc_related .product-variant-select').change(function() {
    var selectedOption = $(this).find('option:selected');
    var price = selectedOption.attr('data-price');
    var comparePrice = selectedOption.attr('data-compare-at-price');
    
    // 가격 요소 업데이트
    if(price == comparePrice){
      $(this).parents('.complementary-item').find('.price').removeClass('price--on-sale');
     $(this).parents('.complementary-item').find('.price__regular').show();
     $(this).parents('.complementary-item').find('.price__sale').hide();
      $(this).parents('.complementary-item').find('.price__regular .money').html(price);
    }else if( $(this).parents('.complementary-item').find('.price__sale .money').length > 0){
      $(this).parents('.complementary-item').find('.price__regular').hide();
      $(this).parents('.complementary-item').find('.price__sale').show();
      $(this).parents('.complementary-item').find('.price-item--sale').html(price);
      $(this).parents('.complementary-item').find('.price-item--regular').html(comparePrice);
      }
    
  });
  
}, 2500);


/*
setTimeout(function(){
  var recommend_prd = new Swiper(".recommend_prd .swiper", {
      slidesPerView:2,
    speed:800,
      spaceBetween: 15,
      autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
  });
  $('.sets_title').show();
  $('.save_with_sets').addClass('show');
}, 3500);

setTimeout(function(){
    var complement = new Swiper(".complementary-products .mySwiper", {
      slidesPerView: 1,
    });
}, 2000);

setTimeout(function(){
       $('.complementary-products__container').addClass('show');
}, 2100);
*/